import { useNavigate } from "react-router-dom";
import { routes } from "../utils/routes";

/**
 * NotFoundPage component
 * Displays a 404 error message when users navigate to a non-existent route
 * Provides navigation back to the workspaces list
 */
export function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoToWorkspaces = () => {
    navigate(routes.workspaces(), { state: { skipAutoRestore: true } });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-4">
      <div className="text-center">
        <h1 className="mb-4 text-6xl font-bold text-black">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-black">Page Not Found</h2>
        <p className="mb-8 text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={handleGoToWorkspaces}
          className="rounded-md border border-black bg-black px-6 py-3 text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
        >
          Go to Workspaces
        </button>
      </div>
    </div>
  );
}
